import { ParcelTypeEnums } from "Data/order";
import {
  AddressStreetType,
  CoordinatesType,
  Day,
  FilePayload,
  NewPasswordType,
  TempDeleteInfoObjectType,
} from "./common.types";

export interface PhoneType {
  dialCode: string;
  number: string;
}

export interface PhoneFormatPayload {
  countryCode: string;
  number: string;
  fullNumber: string;
  type: "HOME" | "OFFICE" | "FAX" | "MOBILE";
}

export interface CustomerFormInputType
  extends AddressStreetType,
    NewPasswordType,
    TempDeleteInfoObjectType,
    CoordinatesType {
  customerName: string;
  emailAddress: string;
  acceptTerms: boolean;
  mobileNo: PhoneType;
  _id?: string;
  locationID?: string;
  orgType: OrgType;
  file?: FilePayload;
  parentOrgID?: string;
  code?: string;
  prefix?: string;
  approvalStatus?: CustomerApprovalStatus;
  customerType: CustomerType;
  coordinates?: CoordinatesType;
  parcelTypes?: ParcelTypeEnums[];
  allowPickupAll: boolean
}

export interface WorkingHour {
  day?: string;
  openingTime?: moment.Moment | null;
  closingTime?: moment.Moment | null;
  isChecked?: boolean;
}

export interface WorkingHours extends Array<WorkingHour> {}

export interface CustomerCompanyFormInputType extends CustomerFormInputType {
  contactNo: PhoneType;
  adminContactNo: PhoneType;
  officeContactNo: PhoneType;
  businessRegistrationNumber: string;
  companyWebsite: string;
  contactPerson: string;
  adminEmailAddress: string;
  primaryEmail: string;
  workingDays: {
    [key in Day]?: boolean;
  };
  closingTime: {
    [key in Day]?: moment.Moment | string | null;
  };
  openingTime: {
    [key in Day]?: moment.Moment | string | null;
  };
  workingHours: WorkingHours;
}

export enum CustomerApprovalStatus {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PENDING = "PENDING",
  UNAPPROVED = "UNAPPROVED",
}

export enum OrgType {
  COMPANY = "COMPANY",
  CUSTOMER = "CUSTOMER",
}

export enum CustomerType {
  COMPANY = "COMPANY",
  INDIVIDUAL = "INDIVIDUAL",
}
